<select
  class="form-select py-0"
  style="height: 21px; font-size: 12px"
  [(ngModel)]="currentZoomIndex"
  (change)="onZoomChange()"
  title="Select a zoom level (the default is 100%)."
>
  @for (factor of zoomFactors; track factor; let i = $index) {
    <option [value]="i">{{ (factor * 100).toFixed(0) }}%</option>
  }
</select>
